import styled from 'styled-components';
import { COLOR_SECONDARY } from '../colors/colors';

export const YouModalContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const YouModalHeaderImage = styled.div`
  display: flex;
  justify-content: center;
  align-self: center;
  width: 100%;
  max-width: 420px;
  margin-bottom: 12px;

  img {
    width: 48px;
    height: 48px;
  }
`;

export const YouModalDescription = styled.p`
  text-align: center;
  width: 100%;
  max-width: 420px;
  align-self: center;
  margin: 0;
  font-size: 14px;
  color: ${COLOR_SECONDARY};
`;

export const YouModalActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
`;
